import { render, staticRenderFns } from "./PhytoResTechnologyPage.vue?vue&type=template&id=6e68f197&scoped=true&"
import script from "./PhytoResTechnologyPage.vue?vue&type=script&lang=js&"
export * from "./PhytoResTechnologyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68f197",
  null
  
)

export default component.exports